import styles from './SplashScreenLoading.module.less';
import cover from '../../assets/images/cover_loading.svg';
import loading from '../../assets/images/composiciones_loading.svg';
import footerSplashMobile from '../../assets/images/footer_splash_mobile.svg';

function SplashScreenLoading() {
  return (
    <>
      <div className={`${styles['splash-screen--bg-texture']} hidden sm:flex w-full h-full items-center fixed`}>
        <img alt="Cover" className="w-2/3 h-2/3" src={cover} />
        <img alt="loading" className={styles['splash-screen__loading']} src={loading} />
        <div className={styles['splash-screen__texts']}>
          <div className={styles['splash-screen__title'] + ' text-primary'}>Artista de archivo</div>
          <div className={styles['splash-screen__caption'] + ' text-primary'}>Composiciones</div>
        </div>
      </div>

      <div className={`${styles['splash-screen--bg-texture']} flex sm:hidden w-full h-full items-center fixed justify-center flex-wrap`}>
        <img alt="Cover" className={`${styles['splash-screen__cover--responsive']}`} src={cover} />
        <img alt="Loading" className={`w-1/2 ${styles['splash-screen__loading--responsive']}`} src={loading} />
        <img alt="Footer" className={`${styles['splash-screen__footer--responsive']}`} src={footerSplashMobile} />
          <div className={`w-full flex flex-wrap justify-center ${styles['splash-screen__texts--responsive']}`}>
              <div className={`${styles['splash-screen__title--responsive']} text-primary`} style={{width: '70%'}}>Artista <br/> de archivo</div>
              <div className={`${styles['splash-screen__caption--responsive']} text-primary`}  style={{width: '70%'}}>Composiciones</div>
          </div>
      </div>
    </>
  );
}

export default SplashScreenLoading;
